import { SearchInput } from '@/components/ui/input';

interface TanstackTableSearchProps {
  placeholder?: string;
  setGlobalFilter: (value: string) => void;
  className?: string;
}

export default function TanstackTableSearch(tanstackTableSearchProps: TanstackTableSearchProps) {
  const { placeholder = 'Wyszukaj...', setGlobalFilter, className } = tanstackTableSearchProps;

  return <SearchInput placeholder={placeholder} setValue={setGlobalFilter} className={className} />;
}
